import { Text, Box } from '@chakra-ui/react';
import { FirebaseVideoInteractionType } from '@novaheal/types';
import { VideoBox } from 'components/common/VideoBox/VideoBox';
import { useFirebase } from 'hooks/useFirebase';
import { logBrazeEvent } from 'utils/brazeEvents';
import { ModalFtuVideoVariantProps, SharedModalProps } from 'types/Modal';
import { CustomModalContent } from '../CustomModalContent';
import { CustomModal } from '../CustomModal';

type Props = SharedModalProps & ModalFtuVideoVariantProps;

export const FtuVideoModal = ({
  isShown,
  handleClose,
  video,
  onModalClose,
}: Props): JSX.Element | null => {
  const { logFirebaseVideo } = useFirebase();

  const handleVideoEnded = (): void => {
    if (video) {
      logFirebaseVideo(FirebaseVideoInteractionType.COMPLETED, video.description, {
        displayType: 'modal',
      });
    }
  };

  const handleVideoAborted = (): void => {
    if (video) {
      logFirebaseVideo(FirebaseVideoInteractionType.ABORTED, video.description, {
        displayType: 'modal',
      });
    }
  };

  const onClose = (): void => {
    logBrazeEvent('onboarding_video_closed', { videoUrl: video?.url });
    if (onModalClose) {
      onModalClose();
    }
    handleClose();
  };

  if (!video) {
    return null;
  }

  return (
    <CustomModal isOpen={isShown} onClose={onClose} placement="center" size="lg">
      <CustomModalContent alignSelf="center" padding={{ base: '0 20px 20px', md: '0 40px 30px' }}>
        <Text mb="10px" textStyle="h3.medium" color="text.secondary">
          Bevor du startest
        </Text>
        <Text mb="25px" textStyle="body.s.regular" color="text.quaternary">
          Schau dir dieses Video an!
        </Text>
        <Box borderRadius="xl" overflow="hidden" width="100%">
          <VideoBox
            videoUrl={video.url}
            videoDescription={video.description}
            onVideoEnd={handleVideoEnded}
            onVideoAbort={handleVideoAborted}
          />
        </Box>
      </CustomModalContent>
    </CustomModal>
  );
};
